module.exports = "/_next/static/images/hero-image-58b9d29062c82255c0a6fe9d6439e08e.png";